import { BasicLayout } from '../../components/BasicLayout';
import { FC, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { PasswordRecoveryFormValues } from '../../../types/ui';
import PasswordRecoveryForm from './PasswordRecoveryForm';
import useAuth from '../../hooks/useAuth';

const PasswordRecoveryScene: FC = () => {
  const { isLoggedIn, recoverByEmail, recoverPasswordStatus } = useAuth();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const isLoading = recoverPasswordStatus === 'loading';

  const passwordRecoverySubmitted = (values: PasswordRecoveryFormValues) => {
    setIsSubmitted(true);
    recoverByEmail(values.email);
  };

  useEffect(() => {
    if (isSubmitted && recoverPasswordStatus === 'success')
      navigate('instructions-sent');
  }, [recoverPasswordStatus, navigate, isSubmitted]);

  if (isLoggedIn) return <Navigate to="/" />;

  return (
    <BasicLayout>
      <PasswordRecoveryForm
        onSubmit={passwordRecoverySubmitted}
        isLoading={isLoading}
      />
    </BasicLayout>
  );
};

export default PasswordRecoveryScene;
